<template>
	<div class="layout">
		<div class="img">
			<v-img v-bind="require('@/assets/images/login.jpg')"/>
		</div>

		<div class="content">
			<router-link :to="{name: 'index'}" class="logo">
				<img src="@/assets/images/logo.png"/>
			</router-link>

			<div class="box">
				<slot/>
			</div>
		</div>
	</div>
</template>

<script>

export default {

};
</script>

<style lang="scss" scoped>
.layout {
	position: relative;
	display: flex;
	flex-direction: row-reverse;

	.img {
		width: 50%;

		@include res(mobile) {
			display: none;
		}

		img {
			object-fit: cover;
			height: 100%;
			width: 100%;
		}
	}

	.content {
		position: relative;
		width: 50%;
		min-height: 100vh;
		background-color: $white1;
		padding: 13px 27px;
		display: flex;
		flex-direction: column;

		@include res(mobile) {
			width: 100%;
			align-items: center;
		}

		.logo {
			width: em(65);

			img {
				display: block;
			}
		}

		.box {
			flex-grow: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			max-width: 345px;
			margin: 0 auto;
			width: 100%;

			/deep/ {
				form {
					input {
						border-bottom: 1px solid #E2E2E2;
					}
				}
			}
		}
	}
}
</style>
